module.exports = "/images/vendor/jquery-ui-bundle/ui-icons_cc0000_256x240.png?bd6996f9c0921f5e744aba81d3dadd84";


//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery-ui-bundle/images/ui-icons_cc0000_256x240.png
// module id = 8wVY
// module chunks = 0